import type { OptionsDocument, UserPreferencesDocument } from 'paintscout'
import type { ThemeOptions } from '@paintscout/ui/styles'
import { createTheme } from '@paintscout/ui/styles'

/**
 * Gets the Theme for authenticated users and customer-view
 */
export function getTheme(args: {
  options?: OptionsDocument
  preferences?: UserPreferencesDocument
  removePrimaryColor: boolean
  customerView?: boolean
}) {
  const { options, preferences, removePrimaryColor, customerView = false } = args

  const baseTheme: ThemeOptions = {
    palette: {
      primary: { main: '#595959' },
      secondary: { main: '#FFFFFF' }
    },
    zIndex: {
      mobileStepper: 1000,
      appBar: 1100,
      drawer: 1200,
      modal: 2_147_483_001,
      snackbar: 2_147_483_002,
      tooltip: 2_147_483_002
    },
    ...(customerView
      ? {
          breakpoints: {
            values: {
              xs: 0,
              sm: 600,
              md: 768,
              lg: 1024, // lg: 1280,
              xl: 1175 // was:1280.
            }
          }
        }
      : {})
  }

  if (!options) {
    return createTheme(baseTheme)
  }

  let fontScale = 1
  if (!options.options?.features?.fontScaling?.enabled) {
    fontScale = 0.9
  } else if (preferences?.fontScale) {
    fontScale = preferences.fontScale
  }

  const secondaryColor = '#FFFFFF'

  const primaryPSBlue = '#0766EE'
  // Blue50, the hover shade of PaintScout blue (ENG-2094). Without it MUI computes its own darker blue.
  const primaryPSBlueDark = '#0559D2'

  const primaryColor = removePrimaryColor ? primaryPSBlue : (options.options.primaryColor.value as string)

  const fullTheme: ThemeOptions = {
    ...baseTheme,
    paintscout: {
      fontScale
    },
    palette: {
      primary: removePrimaryColor ? { main: primaryColor, dark: primaryPSBlueDark } : { main: primaryColor },
      secondary: { main: secondaryColor },
      error: { main: '#F44336' }
    }
  }

  return createTheme(fullTheme)
}
